import { Item } from '../ygdrasil/libs/StrategyViewObjectiveListHelper'

export function shouldShowPopper(item: Item) {
  return !item.isExpanded
}
